module.exports = __webpack_public_path__ + "static/cosmos.OberionIO.min-d75b4c087ecd685bc23b1bf379944145.svg";